import { z } from "zod";

export const accountSchema = z
  .object({
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter a valid email"),
    username: z
      .string()
      .min(5, "Username must be at least 5 characters")
      .max(15, "Username must be at most 15 characters")
      .regex(
        /^[a-zA-Z0-9._-]+$/,
        "Username can only contain letters, numbers, periods, underscores, and hyphens",
      )
      .refine((val) => {
        const prohibitedTerms = ["admin", "root", "system", "hyperpod"];
        return !prohibitedTerms.some((term) =>
          val.toLowerCase().includes(term.toLowerCase()),
        );
      }, "Please select another username."),
    password: z
      .string()
      .min(6, "Password must be at least 6 characters")
      .max(32, "Password must be at most 32 characters")
      .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])/,
        "Password must contain uppercase, lowercase, and special characters",
      ),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export type AccountFormData = z.infer<typeof accountSchema>;
